module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-tooltip', {
    attrs: {
      "content": String(_vm.currentValue),
      "disabled": !_vm.showTips,
      "placement": "bottom"
    }
  }, [_c('div', {
    staticClass: "rt-input",
    class: [
      _vm.resizable ? '' : 'rt-input-resize',
      _vm.type === 'textarea' ? 'rt-xpc-textarea' : '',
      _vm.showWordCount || _vm.showWordLimit ? 'rt-xpc-textarea-count' : ''
    ],
    on: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  }, [_c('el-input', _vm._b({
    ref: "input",
    attrs: {
      "value": _vm.currentValue,
      "type": _vm.type,
      "clearable": false,
      "placeholder": _vm.computedInputPlaceholder,
      "readonly": _vm.readonly,
      "disabled": _vm.computedDisabled,
      "autosize": _vm.autosize,
      "show-password": _vm.showPassword,
      "maxlength": _vm.maxLength,
      "show-word-limit": _vm.showWordLimit,
      "show-word-count": _vm.showWordCount,
      "clear-icon-right": _vm.clearIconRight,
      "input-hovering": _vm.inputHovering,
      "show-close": _vm.showClose
    },
    on: {
      "input": _vm.inputHandler,
      "focus": _vm.focus,
      "blur": _vm.blurHandler,
      "change": _vm.changeHandler
    }
  }, 'el-input', _vm.$attrs, false), [_vm._t("default"), _vm._v(" "), _vm._t("prepend", null, {
    "slot": "prepend"
  }), _vm._v(" "), _vm._t("append", null, {
    "slot": "append"
  }), _vm._v(" "), _vm._t("prefix", null, {
    "slot": "prefix"
  }), _vm._v(" "), _vm._t("textareaSuffix", null, {
    "slot": "textareaSuffix"
  })], 2), _vm._v(" "), (_vm._computedRecordIcon) ? _c('rt-icon', {
    staticClass: "rt-xpc-input-suffix",
    attrs: {
      "slot": "suffix",
      "color": _vm.SCSS_VARIABLES.COLOR_INFO,
      "name": "rt-base-record-lined"
    },
    on: {
      "click": _vm.inputFocus
    },
    slot: "suffix"
  }) : _vm._e(), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
    staticClass: "rt-xpc-input-clearicon",
    style: (_vm.computedClearIconStyle),
    attrs: {
      "slot": "suffix",
      "name": _vm.computedIconName
    },
    on: {
      "click": _vm.clear
    },
    slot: "suffix"
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05f6a6a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtXpcInput.vue
// module id = 2063
// module chunks = 137